import * as yup from "yup";

const SUPPORTED_FORMATS = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const registerCareersSchema = yup.object({
  name: yup
    .string()
    .required("Name is required")
    .matches(/^[A-Za-z\s]+$/, "Name must contain only letters and spaces"),

  email: yup
    .string()
    .required("Email is required")
    .email("Enter a valid email"),

  phone: yup
    .string()
    .required("Phone number is required"),

  attachment: yup
    .mixed()
    .test("required", "File is required", (value) => {
      return value && value.length > 0;
    })
    .test(
      "fileType",
      "Only PDF, DOC, DOCX files are allowed",
      (value) => {
        if (!value || value.length === 0) return true; // required handles empty

        return SUPPORTED_FORMATS.includes(value[0].type);
      }
    ),
});

export default registerCareersSchema;